//Button types
export var BUTTON_TYPES;
(function (BUTTON_TYPES) {
    BUTTON_TYPES["BUTTON_PRIMARY"] = "primary";
    BUTTON_TYPES["BUTTON_PRIMARY_CMP"] = "primary-cmp";
    BUTTON_TYPES["BUTTON_PRIMARY_SMALL"] = "primary-small";
    BUTTON_TYPES["BUTTON_SECONDARY"] = "secondary";
    BUTTON_TYPES["BUTTON_SECONDARY_CMP"] = "secondary-cmp";
    BUTTON_TYPES["BUTTON_LINK"] = "link";
    BUTTON_TYPES["BUTTON_POPUP"] = "popup";
})(BUTTON_TYPES || (BUTTON_TYPES = {}));
